import React from 'react';

interface Props {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  fullPage?: boolean;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-3',
};

const LoadingSpinner: React.FC<Props> = ({ size = 'md', color, fullPage = false }) => {
  const spinner = (
    <div
      className={`animate-spin rounded-full border-surface-200 border-t-primary-600 ${sizeClasses[size]}`}
      style={color ? { borderTopColor: color } : undefined}
      role="status"
      aria-label="Cargando"
    />
  );

  if (fullPage) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
